import { BotApplicationInstanceService } from "./botApplicationInstanceService";
import { AxiosResponse } from 'axios';
import { BotApplicationInstance } from "../../types/botApplicationInstance";

export interface ApiBotApplicationInstances {
    getAppInstanceById(appInstanceId: string): Promise<AxiosResponse>;
    getAppInstances(urlParams: string): Promise<AxiosResponse>;
    getAllBotApplicationInstances(): Promise<AxiosResponse>;
    createBotApplicationInstance(data: BotApplicationInstance): Promise<AxiosResponse>;
    updateBotApplicationInstance(data: BotApplicationInstance): Promise<AxiosResponse>;
    deleteBotApplicationInstance(data: string[]): Promise<AxiosResponse>;
    getAssignToData(): Promise<AxiosResponse>;
}

export const botApplicationInstanceService = new BotApplicationInstanceService();